export default __webpack_public_path__ + "static/media/expose5.f8138da5.png";